<template>
  <div v-if="stageContenttData.method == 'META_LA'" class="flex flex-wrap -mb-4" style="position:relative" :style="guideStep >= 13 && !isAreadlyOpenshowTargetLA ? { zIndex: 100 } : null">
    <loading :active="showAdvertisingMixMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6">
      <!-- <div>
        <span class="text-red-500">*</span>
        <span class="text-grap-700 align-middle">{{lang['components']['Event']['AdvertisingMix']['title']}}</span>
        <i
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
          v-tooltip="`${lang['components']['Event']['AdvertisingMix']['title_info']}`"
        ></i>
      </div> -->
      <div class="flex-1 space-y-4">
        <div class="space-y-2">
          <div class="flex justify-between">
            <span class="text-grap-700 text-sm pt-4">{{lang['components']['Event']['AdvertisingMix']['default_block_title']}}
              <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['AdvertisingMix']['default_block_title_info']}`"></i>
            </span>
            <!-- 新手教學 -->
            <button
              v-if="!editPageType"
              class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 transition duration-500 ease-in-out border-2 border-blue-600"
              :class="{ 'ring-4 border-blue-400': guideStep === 17 }"
              @click="audience_update()"
            >
              <i class="pi pi-refresh"></i>
              {{lang['components']['Event']['AdvertisingMix']['update']}}
            </button>
          </div>
          <!-- 新手教學 -->
          <div class="flex flex-wrap bg-white w-full p-2 rounded-md border" :class="{ 'ring-4 border-blue-400': guideStep === 14 }">
            <template v-for="(tag, index) in stageContenttData.lookData.default_lookalikes_list" :key="tag.code">
              <!-- <div
                class="rounded m-1 px-2 py-1 text-sm cursor-pointer"
                :class="[
                  tag.checked ? 'bg-blue-400' : ' bg-gray-200',
                  tag.checked ? 'text-white' : 'text-gray-400'
                ]"
                @click="tag.checked = !tag.checked"
              >
                {{ tag.name }}
              </div> -->
              <div
                class="rounded m-1 px-2 py-1 text-sm cursor-pointer"
                :class="[
                  tag.checked ? 'bg-blue-400' : ' bg-gray-200',
                  tag.checked ? 'text-white' : 'text-gray-400'
                ]"
                @click="defaultLookalikesChecked(tag.checked, index, tag.code)"
              >
                {{ tag.name }}
              </div>
            </template>
          </div>
          <div class="pt-8">
            <span class="text-grap-700 align-middle text-sm"
              >{{lang['components']['Event']['AdvertisingMix']['customize_block_title']}}</span
            >
          </div>
          <!-- 新手教學 -->
          <MultiSelect
            :disabled="editPageType"
            v-model="stageContenttData.lookData.custom_lookalikes_selected"
            :options="stageContenttData.lookData.custom_lookalikes_list"
            optionLabel="name"
            :placeholder="lang['components']['Event']['AdvertisingMix']['customize_block_title_placeholder']"
            :filter="true"
            class="w-full multiselect-custom"
            :class="{ 'ring-4 border-blue-400': guideStep === 16 }"
            display="chip"
            @change="onChange($event)"
          >
          </MultiSelect>
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar">
      <div class="flex flex-col bg-white rounded-xl space-y-4 p-4">
        <span class="text-gray-700">{{lang['components']['Event']['AdvertisingMix']['select_block_title']}}</span>
        <!-- 新手教學 -->
        <div
          class="flex flex-col bg-white w-full p-2 rounded-xl border h-48 overflow-y-auto"
          :class="{ 'ring-4 border-blue-400': guideStep === 15 }"
        >
          <template v-for="(tag, index) in stageContenttData.lookData.default_lookalikes_list" :key="tag.code">
            <div
              :disabled="editPageType"
              class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white"
              :class="[
                tag.checked ? 'bg-blue-400' : ' bg-gray-200',
                tag.checked ? 'text-white' : 'text-gray-400'
              ]"
              @click="defaultLookalikesChecked(tag.checked, index, tag.code)"
              v-if="tag.checked"
            >
              <span style="word-break: break-all;">{{ tag.name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <template v-for="tag in stageContenttData.lookData.custom_lookalikes_selected" :key="tag.code">
            <div
              class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white"
              @click="removeSelectCustomTags(tag.code)"
            >
              <span style="word-break: break-all;">{{ tag.name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MultiSelect from "primevue/multiselect";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "AdvertisingMix",
  components: {
    MultiSelect,
    Loading
  },
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: -1
    },
    // <!-- 新手教學 -->
    showAdvertisingMix: {
      type: Boolean
    },
    editPage: {
      type: Boolean
    },
    adaccountId: {
      type: String
    },
    pixelId: {
      type: String
    },
    productUrl: {
      type: String
    },
    viewDatalist: {
      type: Object
    },
    stageContent:{
      type: Object
    },
    formEventAddLoadingLA: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      showAdvertisingMixMyside: false,
      selectedCustomTags: [],
      customTags: [],
      tags: []
    };
  },
  watch:{
    showAdvertisingMix(val){
      // console.log('ad showAdvertisingMix');
      // console.log(val);

      let tmpStatus = val.split('_');

      // console.log('ad tmpStatus');
      // console.log(tmpStatus);
      // console.log(typeof tmpStatus[0]);

      if(tmpStatus[0] == 'false'){
        this.showAdvertisingMixMyside = false
      } else {
        this.showAdvertisingMixMyside = true
      }
    },
    viewDatalist(val){
      // console.log('showAdvertisingMix val');
      // console.log(val);
      this.showAdvertisingMixMyside = false
    },
    'stageContenttData.lookData':function(value){
      // console.log('StageAdvertisingMix stageContenttData.lookData');
      // console.log(value);
    }
  },
  methods: {
    removeSelectCustomTags(id) {
      for (let i = 0; i < this.stageContenttData.lookData.custom_lookalikes_selected.length; i++) {
        if (this.stageContenttData.lookData.custom_lookalikes_selected[i].code === id) {
          this.stageContenttData.lookData.custom_lookalikes_selected.splice(i, 1);
        }
      }
    },
    defaultLookalikesChecked(checked, index, code){
      let itemLength = 0
      let url_error = 0

      if(this.editPageType == false){
        if(code == 'url_view'){
          if(this.productUrlData == '' || this.productUrlData == null){
            Swal.fire(
                        this.lang['components']['Event']['AdvertisingMix']['methods']['swal_title'],
                        this.lang['components']['Event']['AdvertisingMix']['methods']['defaultLookalikesChecked']['not_productUrlData_swal_text'],
                        "error"
                      )
            url_error = 1;
          }
        }

        if(url_error == 0){
          for (let i = 0; i < this.stageContenttData.lookData.default_lookalikes_list.length; i++) {
            if (this.stageContenttData.lookData.default_lookalikes_list[i].checked == true) {
              itemLength = parseInt(itemLength) + parseInt(1);
            }
          }

          itemLength = parseInt(itemLength) + this.stageContenttData.lookData.custom_lookalikes_selected.length

          if(checked == false){
            if(itemLength < 5){
              for (let i = 0; i < this.stageContenttData.lookData.default_lookalikes_list.length; i++) {
                if (this.stageContenttData.lookData.default_lookalikes_list[i].code === code) {
                  this.stageContenttData.lookData.default_lookalikes_list[i].checked = true
                }
              }
            } else {
              Swal.fire(
                        this.lang['components']['Event']['AdvertisingMix']['methods']['swal_title'],
                        this.lang['components']['Event']['AdvertisingMix']['methods']['defaultLookalikesChecked']['not_itemLength_swal_text'],
                        "error"
                      )
            }
          } else {
            for (let i = 0; i < this.stageContenttData.lookData.default_lookalikes_list.length; i++) {
              if (this.stageContenttData.lookData.default_lookalikes_list[i].code === code) {
                this.stageContenttData.lookData.default_lookalikes_list[i].checked = false
              }
            }
          }
        }
      }
    },
    audience_update(){
      // console.log('audience_update');

      if(this.editPageType == false){
        this.showAdvertisingMixMyside = true;

        // console.log('this.pixelIdData');
        // console.log(this.pixelIdData);

        axios
          .post('https://www.autoturn.net/api/campaign_lookalikes_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.adaccountIdData,
            pixel_id: this.pixelIdData,
            product_url: this.productUrlData,
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'success'){
              // this.immediateList = response.data.return_data
              // this.formData = response.data.return_data.form

              // if(type == 1){
              //   var todayForm = new Date();
              //   var yearForm = todayForm.getFullYear();
              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

              //   todayForm = yearForm + monthForm + dateForm + timeForm;

              //   this.formTitle = 'title_'+todayForm;
              // } else {
              //   this.formTitle = response.data.return_data.name;
              // }

              // this.showModal = true
              this.stageContenttData.lookData.default_lookalikes_list = response.data.return_data.default_lookalikes_list
              this.stageContenttData.lookData.custom_lookalikes_selected = []
              // console.log('b this.stageContenttData.lookData.custom_lookalikes_list');
              // console.log(this.stageContenttData.lookData.custom_lookalikes_list);
              this.stageContenttData.lookData.custom_lookalikes_list = response.data.return_data.custom_lookalikes_list
              // console.log('a this.stageContenttData.lookData.custom_lookalikes_list');
              // console.log(this.stageContenttData.lookData.custom_lookalikes_list);
            }

            this.showAdvertisingMixMyside = false;
          });
      }
    },
    onChange(event) {
      // this.selectAll = event.value.length === this.items.length
      let itemLength = 0

      if(this.editPageType == false){
        for (let i = 0; i < this.stageContenttData.lookData.default_lookalikes_list.length; i++) {
          if (this.stageContenttData.lookData.default_lookalikes_list[i].checked == true) {
            itemLength = parseInt(itemLength) + parseInt(1);
          }
        }

        itemLength = parseInt(itemLength) + event.value.length

        if(itemLength > 5){
          event.value.pop();

          Swal.fire(
                      this.lang['components']['Event']['AdvertisingMix']['methods']['swal_title'],
                      this.lang['components']['Event']['AdvertisingMix']['methods']['onChange']['not_itemLength_swal_text'],
                      "error"
                    )
        }
      }
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    adaccountIdData: {
      get: function () {
        return this.adaccountId
      },
      set: function (value) {
        this.$emit('update:adaccountIdData', value)
      },
    },
    pixelIdData: {
      get: function () {
        return this.pixelId
      },
      set: function (value) {
        this.$emit('update:pixelIdData', value)
      },
    },
    productUrlData: {
      get: function () {
        return this.productUrl
      },
      set: function (value) {
        this.$emit('update:productUrlData', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    stageContenttData:{
      get: function () {
        return this.stageContent
      },
      set: function (value) {
        this.$emit('update:stageContenttData', value)
      },
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep(.multiselect-custom) {
  .p-multiselect-token {
    font-size: 0.875rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-radius: 0.25rem;
    display: inline-flex;
    margin: 0.25rem;
    --tw-bg-opacity: 1;
    background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
  }
}
</style>
